module.exports = __webpack_public_path__ + "f8a99074840595f621471f1c794be00e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/25_PROP_05.png
// module id = 126
// module chunks = 0